<template>
  <q-page class="container" padding>
    <!-- Cabeçalho -->
    <div class="row col-12 justify-between align-center q-mb-md">
      <p class="text-h6 text-brand-1 text-weight-bolder">
        Treinamento Usuários
      </p>
      <q-btn
        label="Novo Treinamento"
        no-caps
        icon="add"
        style="background-color: #21324a; border-radius: 8px; color: white"
        @click="abrirModalCriar"
      />
    </div>

    <!-- Filtros -->
    <div
      class="row no-wrap col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md items-end"
    >
      <div style="width: 30%">
        <div class="input-label">Tenant</div>
        <q-input
          class="input-modal input-new-design"
          v-model="filtros.tenant"
          dense
          autocomplete="off"
          outlined
          maxlength="100"
          placeholder="Filtrar por tenant"
        />
      </div>
      <div style="width: 30%">
        <div class="input-label">E-mail do Usuário</div>
        <q-input
          class="input-modal input-new-design"
          v-model="filtros.userEmail"
          dense
          autocomplete="off"
          outlined
          maxlength="200"
          placeholder="Filtrar por e-mail"
        />
      </div>
      <div style="width: 30%">
        <div class="input-label">SAP do Usuário</div>
        <q-input
          class="input-modal input-new-design"
          v-model="filtros.userSap"
          dense
          autocomplete="off"
          outlined
          maxlength="100"
          placeholder="Filtrar por SAP"
        />
      </div>
      <div>
        <q-btn
          label="Buscar"
          no-caps
          icon="search"
          style="background-color: #21324a; border-radius: 8px; color: white"
          @click="listar"
        />
      </div>
    </div>

    <!-- Tabela -->
    <div class="q-mt-md">
      <q-table
        :rows="lista"
        :columns="columns"
        row-key="id"
        :loading="loading"
        flat
        bordered
        no-data-label="Nenhum registro encontrado"
        rows-per-page-label="Linhas por página"
        :rows-per-page-options="[15, 25, 50, 100]"
        :pagination="{ rowsPerPage: 15 }"
      >
        <template v-slot:loading>
          <q-inner-loading showing>
            <q-spinner-gears size="48px" color="primary" />
          </q-inner-loading>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props">
            <q-td key="tenant" :props="props">{{ props.row.tenant }}</q-td>
            <q-td key="userName" :props="props">{{ props.row.userName }}</q-td>
            <q-td key="userEmail" :props="props">{{
              props.row.userEmail
            }}</q-td>
            <q-td key="userSap" :props="props">{{ props.row.userSap }}</q-td>
            <q-td key="dataTreinamentoWeb" :props="props">{{
              props.row.dataTreinamentoWeb || "-"
            }}</q-td>
            <q-td key="dataVencimentoTreinamentoWeb" :props="props">{{
              props.row.dataVencimentoTreinamentoWeb || "-"
            }}</q-td>
            <q-td key="modulos" :props="props" class="center">
              <q-btn
                v-if="
                  props.row.modulosTreinamentoWeb &&
                  props.row.modulosTreinamentoWeb.length > 0
                "
                icon="menu_book"
                flat
                color="primary"
                dense
                no-caps
                @click="verModulos(props.row)"
              >
                <q-tooltip>Ver conteúdo programático</q-tooltip>
              </q-btn>
              <span v-else class="text-grey-4">—</span>
            </q-td>
            <q-td key="editar" :props="props" class="center">
              <q-btn
                icon="sym_o_edit"
                flat
                color="primary"
                dense
                no-caps
                @click="abrirModalEditar(props.row)"
              />
            </q-td>
            <q-td key="remover" :props="props" class="center">
              <q-btn
                icon="sym_o_delete"
                flat
                color="red"
                dense
                no-caps
                @click="confirmarDelete(props.row)"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>

    <!-- Dialog módulos -->
    <q-dialog v-model="modulosDialogAberto">
      <q-card style="min-width: 420px; max-width: 600px">
        <q-bar style="background-color: #21324a; color: white">
          <q-icon name="menu_book" />
          <span class="q-ml-sm text-weight-bold">Conteúdo Programático</span>
          <q-space />
          <q-btn dense flat icon="close" color="white" v-close-popup />
        </q-bar>
        <q-card-section>
          <div class="text-caption text-grey-6 q-mb-sm">
            {{ modulosDialogRegistro?.userName }} —
            {{
              modulosDialogRegistro?.dataTreinamentoWeb ||
              modulosDialogRegistro?.dataTreinamento ||
              "-"
            }}
          </div>
          <q-list dense separator>
            <q-expansion-item
              v-for="modulo in modulosDialogRegistro?.modulosTreinamentoWeb"
              :key="modulo.nome"
              :label="modulo.nome"
              :caption="`${
                modulo.totalConteudos ?? modulo.conteudos?.length ?? 0
              } conteúdo(s)`"
              header-class="text-weight-bold text-brand-1"
              expand-separator
            >
              <q-card-section class="q-pt-xs q-pb-sm">
                <div
                  v-for="conteudo in modulo.conteudos"
                  :key="conteudo.nome"
                  class="row items-center q-mb-xs"
                >
                  <q-icon
                    name="check"
                    color="positive"
                    size="16px"
                    class="q-mr-xs"
                  />
                  <span class="text-body2">{{ conteudo.nome }}</span>
                </div>
              </q-card-section>
            </q-expansion-item>
          </q-list>
        </q-card-section>
      </q-card>
    </q-dialog>

    <!-- Formulário de sessão de treinamento -->
    <TreinamentoSessaoForm
      v-model="sessoesFormAberto"
      :modoEditar="modoEditar"
      :registroEditar="registroEditar"
      @salvo="aoSalvar"
    />

    <!-- Dialog confirmação de delete -->
    <dialog-confirm-design
      mensagem="Tem certeza que deseja excluir este registro de treinamento?"
      :exibir="confirmarDeleteAberto"
      @resultado="executarDelete"
    />
  </q-page>
</template>

<script>
import { ref, computed, onMounted } from "vue";
import { useQuasar } from "quasar";
import { watchDebounced } from "@vueuse/core";
import { useStore } from "vuex";
import DialogConfirmDesign from "../../../components/DialogConfirmDesign.vue";
import TreinamentoSessaoForm from "./TreinamentoSessaoForm.vue";
import { treinamentoUsuariosService } from "../../../services/treinamentoUsuariosService";

export default {
  name: "TreinamentoUsuarios",
  components: { DialogConfirmDesign, TreinamentoSessaoForm },
  setup() {
    const $q = useQuasar();
    const store = useStore();
    const usuarioLogado = computed(
      () => store.getters["autenticacao/usuarioLogado"]
    );

    const loading = ref(false);
    const lista = ref([]);
    const sessoesFormAberto = ref(false);
    const modoEditar = ref(false);
    const registroEditar = ref(null);
    const confirmarDeleteAberto = ref(false);
    const idParaDeletar = ref(null);
    const modulosDialogAberto = ref(false);
    const modulosDialogRegistro = ref(null);

    function verModulos(registro) {
      modulosDialogRegistro.value = registro;
      modulosDialogAberto.value = true;
    }

    const filtros = ref({
      tenant: "",
      userEmail: "",
      userSap: "",
    });

    const columns = [
      {
        name: "tenant",
        label: "Tenant",
        field: "tenant",
        align: "left",
        sortable: true,
      },
      {
        name: "userName",
        label: "Nome",
        field: "userName",
        align: "left",
        sortable: true,
      },
      {
        name: "userEmail",
        label: "E-mail",
        field: "userEmail",
        align: "left",
        sortable: true,
      },
      {
        name: "userSap",
        label: "SAP",
        field: "userSap",
        align: "left",
        sortable: true,
      },
      {
        name: "dataTreinamentoWeb",
        label: "Data Treinamento Web",
        field: "dataTreinamentoWeb",
        align: "left",
        sortable: true,
      },
      {
        name: "dataVencimentoTreinamentoWeb",
        label: "Vencimento Treinamento Web",
        field: "dataVencimentoTreinamentoWeb",
        align: "left",
        sortable: true,
      },
      { name: "modulos", label: "Módulos", align: "center" },
      { name: "editar", label: "Editar", align: "center" },
      { name: "remover", label: "Remover", align: "center" },
    ];

    async function listar() {
      loading.value = true;
      try {
        const resposta = await treinamentoUsuariosService.listar({
          tenant: filtros.value.tenant || undefined,
          userEmail: filtros.value.userEmail || undefined,
          userSap: filtros.value.userSap || undefined,
        });
        lista.value = resposta.data?.results ?? [];
      } catch {
        $q.notify({
          type: "negative",
          message: "Erro ao carregar a listagem.",
        });
      } finally {
        loading.value = false;
      }
    }

    function abrirModalCriar() {
      modoEditar.value = false;
      registroEditar.value = null;
      sessoesFormAberto.value = true;
    }

    function abrirModalEditar(registro) {
      modoEditar.value = true;
      registroEditar.value = registro;
      sessoesFormAberto.value = true;
    }

    function aoSalvar() {
      loading.value = true;
      setTimeout(() => {
        listar();
      }, 800);
    }

    function confirmarDelete(registro) {
      idParaDeletar.value = registro.id;
      confirmarDeleteAberto.value = true;
    }

    async function executarDelete(confirmado) {
      confirmarDeleteAberto.value = false;
      if (!confirmado) return;
      try {
        await treinamentoUsuariosService.deletar(idParaDeletar.value, {
          alteradoPorNome: usuarioLogado.value?.nome || "",
          alteradoPorEmail: usuarioLogado.value?.email || "",
        });
        $q.notify({
          type: "positive",
          message: "Registro excluído com sucesso.",
        });
        loading.value = true;
        setTimeout(() => {
          listar();
        }, 800);
      } catch {
        $q.notify({ type: "negative", message: "Erro ao excluir o registro." });
      }
    }

    watchDebounced(
      filtros,
      () => {
        listar();
      },
      { debounce: 500, deep: true }
    );

    onMounted(() => {
      listar();
    });

    return {
      loading,
      lista,
      filtros,
      columns,
      sessoesFormAberto,
      modoEditar,
      registroEditar,
      confirmarDeleteAberto,
      modulosDialogAberto,
      modulosDialogRegistro,
      listar,
      abrirModalCriar,
      abrirModalEditar,
      aoSalvar,
      confirmarDelete,
      executarDelete,
      verModulos,
    };
  },
};
</script>
